var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEdible = function SvgEdible(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edible_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edible_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M7.257 34.208a.894.894 0 0 0 .288 1.634 4.067 4.067 0 0 1 3.564 4.101.893.893 0 0 0 .948.949 4.07 4.07 0 0 1 4.11 3.563.894.894 0 0 0 1.633.288c2-3.238 4.455-8.616 1.269-11.803s-8.569-.73-11.812 1.268M34.208 7.257a.893.893 0 0 1 1.634.288 4.067 4.067 0 0 0 4.101 3.563.893.893 0 0 1 .949.949 4.07 4.07 0 0 0 3.563 4.11.893.893 0 0 1 .288 1.633c-3.238 2-8.617 4.455-11.803 1.268-3.187-3.186-.73-8.568 1.268-11.811"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.554,
    d: "M16.185 26a9.815 9.815 0 1 0 19.63 0 9.815 9.815 0 0 0-19.63 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.863 21.372c-.29-.16-.585-.315-.863-.497-.14 0-.747 1.307-.797 1.406-.26.52-.315 1.108-.462 1.663-.156.587-.153 1.206-.3 1.793-.083.336-.198.625-.198.982 0 .182-.032.274.088.394.124.124.247.254.368.382.191.205.51.291.745.438.213.133.467.21.703.293.6.21 1.167.485 1.75.738.533.232 1.006.582 1.559.772.17.058.316.166.491.218.131.038.262.08.394.117.243.07.53.146.784.146.303 0 .628.061.924.117.191.036.391.057.586.059.12.001.283-.03.4.006.274.085.57.052.857.052s.58.02.864-.022c.692-.103 1.412-.12 2.092-.284.234-.056.488-.077.713-.162.233-.088.46-.189.693-.277.26-.098.539-.147.784-.28.259-.14.536-.26.807-.374.257-.107.526-.213.796-.284.291-.078.558-.22.844-.308.49-.15.907-.451 1.37-.659.175-.078.348-.094.416-.284a1.2 1.2 0 0 0 .066-.347c0-.318.119-.634.144-.952a5.4 5.4 0 0 0-.027-1.23c-.09-.563-.014-1.126-.147-1.682-.08-.338-.156-.681-.263-1.012-.124-.38-.327-.712-.505-1.067-.052-.104-.086-.29-.213-.192a1 1 0 0 0-.177.177 1.7 1.7 0 0 1-.488.396c-.338.198-.668.38-1.019.556-.834.417-1.699.65-2.606.85-.374.081-.78.08-1.145.191a4.3 4.3 0 0 1-1.513.182c-.687-.047-1.362-.156-2.042-.257-.406-.06-.777-.185-1.17-.307-.107-.034-.201-.103-.315-.103a2 2 0 0 1-.316-.022c-.212-.03-.434.004-.644-.043a9 9 0 0 0-.749-.14c-.25-.034-.45-.132-.686-.198-.445-.124-.886-.196-1.318-.373-.431-.176-.869-.348-1.276-.572Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M16.185 26a9.815 9.815 0 1 0 19.63 0 9.815 9.815 0 0 0-19.63 0"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M35.775 26.895a15.175 15.175 0 0 1-19.55 0m18.127-6.073a15.19 15.19 0 0 1-16.685.011"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "edible_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h52v52H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "edible_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6 6h40v40H6z"
  })))));
};
export default SvgEdible;